<template>
  <div class="places page-component">
    <div class="places-container container-xl">
      <places-list @listChanged="(newList) => places = newList" 
                   @typeChanged="(newType) => selectedType = newType" 
                   @focusPlace="(place) => focusedPlace = place"
      />
      <places-map :places="places" 
                  :selectedType="selectedType"
                  :focusedPlace="focusedPlace"
      />
    </div>
  </div>
</template>

<script>
import PlacesMap from './PlacesMap.vue'
import PlacesList from './PlacesList.vue'

export default {
  name: 'Places',
  components: {
    PlacesMap,
    PlacesList
  },
  data () {
    return {
      places: [],
      selectedType: 'restaurant',
      focusedPlace: null
    }
  }
}
</script>